/*global google:true*/
import { useCallback, useEffect, useState } from "react";
import { GOOGLE_API_URL } from "./constants";

const SCRIPT_ID = "google-places-api-script";

const useGooglePlacesAPI = () => {
  const [autocompleteService, setAutocompleteService] = useState(null);
  const [placesService, setPlacesService] = useState(null);

  const createServices = useCallback(() => {
    setTimeout(() => {
      setAutocompleteService(new google.maps.places.AutocompleteService());
      setPlacesService(new google.maps.places.PlacesService(document.createElement("div")));
    }, 1000);
  }, []);

  useEffect(() => {
    if (!document.getElementById(SCRIPT_ID)) {
      const script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.src = GOOGLE_API_URL;
      script.onload = createServices;

      document.body.appendChild(script);
    } else {
      createServices();
    }
  }, []);

  return [placesService, autocompleteService];
};

export default useGooglePlacesAPI;
